import React from 'react'
import SearchSelectorDropdown from './searchSelectorDropdown'

const SearchSelector = () => {
  return (
      <SearchSelectorDropdown />
  )
}

export default SearchSelector